import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "../../context/authContext";
import { useNavigate, useParams } from "react-router";
import { useForm } from "react-hook-form";
import {
  useHiremeMutation,
  useMutationFavouritelike,
} from "../../actions/homeActions";
import { usePortfolio } from "../../actions/homeActions";
import localimgpath from "../../js/localimgpath";

export default () => {
  const [showForm, setShowForm] = useState(false);
  const [success, setsuccess] = useState(false);
  const [loadingapi, setLoadingapi] = useState(false);
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const userData = useSelector((state) => state.app.userData.userData);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projectTitle: "",
      description: "",
      duration: "",
      startDate: "",
      budget: "",
    },
  });
  const {
    data: portfolio,
    isLoading,
    isError,
    error,
    refetch,
  } = usePortfolio(id);
  const mutation = useHiremeMutation(
    setLoadingToapi,
    setShowForm,
    setsuccess,
    reset
  );
  const mutationFavouritelike = useMutationFavouritelike(setLoadingapi);
  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const submitData = {
      talent_id: id,
      company_id: userData?.employer?.id,
      project_title: data.projectTitle,
      description: data.description,
      duration: data.duration,
      start_date: data.startDate,
      budget: data.budget,
    };
    mutation.mutate(submitData);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <p className="text-secondary">
          Error loading talent Profile: {error.message}
        </p>
      </div>
    );
  }

  const userInfo = [
    // Basic Information
    // { title: "Real Name", value: portfolio?.real_name || "" },
    { title: "Stage Name", value: portfolio?.stage_name || "" },
    { title: "Age", value: portfolio?.age ? `${portfolio.age} Years` : "" },
    { title: "Gender", value: portfolio?.gender?.gender || "" },
    // { title: "Agent Code", value: portfolio?.agent_code || "" },
    
    // Location Information
    // { title: "City", value: portfolio?.city?.city || "" },
    // { title: "State", value: portfolio?.state?.state || "" },
    // { title: "Country", value: portfolio?.country?.country || "" },
    // { title: "Nationality", value: portfolio?.country?.nationality || "" },
    // { title: "Zip Code", value: portfolio?.zip_code || "" },
    
    // Contact Information
    // { 
    //   title: "Mobile Number", 
    //   value: portfolio?.mobile_number 
    //     ? `${portfolio.country_code} ${portfolio.mobile_number}` 
    //     : "" 
    // },
    // { title: "Home Phone", value: portfolio?.home_phone || "" },
    { title: "Website", value: portfolio?.your_website || "" },
    
    // Professional Information
    { title: "Profession", value: portfolio?.stage_name || "" },
    { title: "Education", value: portfolio?.qualification || "" },
    { 
      title: "Experience Level", 
      value: portfolio?.experience_level?.job_experience || "" 
    },
    // { 
    //   title: "Job Categories", 
    //   value: portfolio?.desired_job_types?.length > 0
    //     ? portfolio.desired_job_types.map(job => job.name).join(", ")
    //     : ""
    // },
    { 
      title: "Languages Spoken", 
      value: portfolio?.languages_spoken
        ?.filter(lang => lang?.lang)
        .map(lang => lang.lang)
        .join(", ") || ""
    },
    { title: "Other Languages", value: portfolio?.other_language || "" },
    // { title: "Other Experience", value: portfolio?.other_experience || "" },
    // { title: "Representation", value: portfolio?.representation || "" },
    
    // Preferences
    { 
      title: "Willing to Travel", 
      value: portfolio?.willing_to_travel === 1 ? "Yes" : "No" 
    },
    { 
      title: "Willing to Relocate", 
      value: portfolio?.willing_to_relocate === 1 ? "Yes" : "No" 
    },
    // { 
    //   title: "Display Resume", 
    //   value: portfolio?.display_resume === 1 ? "Yes" : "No" 
    // },
  ];

  // Physical Attributes (only if not off-screen)
  if (portfolio?.off_screen !== 1) {
    userInfo.push(
      {
        title: "Height",
        value: portfolio?.height && portfolio.height !== "null"
          ? `${portfolio.height} cm`
          : "",
      },
      {
        title: "Weight",
        value: portfolio?.weight && portfolio.weight !== "null"
          ? `${portfolio.weight} kg`
          : "",
      },
      {
        title: "Eye Color",
        value: portfolio?.eye_color?.name || "",
      },
      {
        title: "Hair Type",
        value: portfolio?.hair_type?.name || "",
      },
      {
        title: "Ethnicity",
        value: portfolio?.ethnicity?.name || "",
      },
      // {
      //   title: "Body Type",
      //   value: portfolio?.body_type || "",
      // },
      // {
      //   title: "Sexual Orientation",
      //   value: portfolio?.sexual_orientation || "",
      // },
      {
        title: "Tattoos",
        value: portfolio?.tattoos === 1 ? "Yes" : "No",
      },
      {
        title: "Piercings",
        value: portfolio?.piercings === 1 ? "Yes" : "No",
      },
      // {
      //   title: "Body Modification",
      //   value: portfolio?.body_modification || "",
      // },
      // {
      //   title: "Nudity Okay",
      //   value: portfolio?.nudity_okay === 1 ? "Yes" : "No",
      // }
    );
  }

  const chunkData = (arr, chunkSize) =>
    arr.reduce((result, _, index) => {
      if (index % chunkSize === 0)
        result.push(arr.slice(index, index + chunkSize));
      return result;
    }, []);

  // Filter out empty values
  const filteredUserInfo = userInfo.filter(item => 
    item.value && 
    item.value.toString().trim() !== "" &&
    item.value !== "null"
  );

  // Create columns from filtered data (ONLY ONCE!)
  const columns = chunkData(filteredUserInfo, Math.ceil(filteredUserInfo.length / 3));


  const galleryImages = portfolio?.galleries?.map((item) => ({
    original: `${localimgpath?.talentGallery}/${item?.image}`,
    thumbnail: `${localimgpath?.talentGallery}/${item?.image}`,
    originalAlt: item?.title || "Gallery Image",
    description: item?.title || "",
  }));

  const openGallery = (index) => {
    setSelectedIndex(index);
    setIsOpen(true);
  };

  const closeGallery = () => setIsOpen(false);

  return {
    isLoading,
    portfolio,
    userData,
    isLoggedIn,
    navigate,
    setShowForm,
    showForm,
    setLoadingapi,
    mutationFavouritelike,
    refetch,
    localimgpath,
    openGallery,
    closeGallery,
    isOpen,
    galleryImages,
    selectedIndex,
    success,
    setsuccess,
    control,
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    loadingToapi,
    columns,
  };
};